import styles from './ActionBar.css'
import {reduxForm, Field} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect'
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import MenuTitle from 'components/MenuTitle'
import {ActionBarWrapper} from 'components/wrappers/pages'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  render () {
    let {outlets} = this.props
    let status = [
      {
        id: '0',
        name: 'All'
      },
      {
        id: '1',
        name: 'Completed'
      },
      {
        id: '2',
        name: 'Cancelled'
      }
    ]
    return (
      <div className={styles.wrapper}>
        <MenuTitle menuTitle='Table Report' />
        { !isFullSiteMode() &&
          <div className='col-sm-4 hidden-xs col-md-6 action-table-report'>
            <span className='pull-right'>
              <button className='btn btn-primary' onClick={this._onClickExport}>Export</button>
            </span>
          </div>
        }
        <ActionBarWrapper>
          <div className={`col-sm-12 col-xs-12 ${styles['action-bar']}`}>
            <div className={styles['btn-outlet']}>
              <Field
                name='outletIds'
                component={DropdownOutlet}
                outlets={outlets}
                onChangeOutletIds={this._onChangeOutletIds}
              />
            </div>
            <div className={styles['btn-search']}>
              <Field
                component={DropdownCalendar}
                name='date'
                onChange={this._onChangeDate}
                updateServerOnChange
              />
            </div>
            <div className={styles['btn-search']}>
              <Field
                name='statusIds'
                component={DropdownSelect}
                options={status}
                onChange={this._onChangeStatus}
              />
            </div>
          </div>
        </ActionBarWrapper>
      </div>
    )
  }

  _onChangeStatus = (event, statusId) => {
    this.props.onChangeStatus(statusId)
  }

  _onChangeOutletIds = (outletIds) => {
    this.props.onChangeOutlet(outletIds)
  }

  _onChangeDate = ({startDate, endDate}) => {
    this.props.onChangeDate({startDate, endDate})
  }

  _onClickExport = () => {
  }
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  let {groups, summary, groupDetail, currentPage, totalPage, outlets} = state.tableManagement.group
  return {
    outlets,
    groups,
    groupDetail,
    currentPage,
    totalPage,
    summary
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementReport/ActionBar/ActionBar.js